import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Skeleton } from "@evolua/ui";
import { useAuth } from "../auth/AuthContext.js";
import { getAuthMode } from "../auth/config.js";
import { buildLoginPath } from "../auth/auth-redirect.js";
import "../auth/auth.css";

export function RequireAuth() {
  const mode = getAuthMode();
  const { status } = useAuth();
  const location = useLocation();

  if (mode === "demo") {
    return <Outlet />;
  }

  if (status === "loading") {
    return (
      <div className="evolua-auth-boot" role="status" aria-busy="true">
        <Skeleton height="3rem" width="12rem" label="Carregando sessão" />
      </div>
    );
  }

  if (status !== "authenticated") {
    const returnUrl = `${location.pathname}${location.search}`;
    return <Navigate to={buildLoginPath({ returnUrl })} replace />;
  }

  return <Outlet />;
}
